import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FixedList } from '../models/fixedlist.model';

@Injectable()
export class WeekdayTypeService {
  private weekdayTypeUrl: string = 'api/weekdaytypes';

  constructor(
    private http: HttpClient) { }

  getweekdays(): Observable<FixedList[]> {
    return this.http.get<FixedList[]>(this.weekdayTypeUrl);
  }
}

